module.exports = __webpack_public_path__ + "media/images/country_flags/sz-57813cd14215286008312c4627ae50f1.png";